export const YANDEX_METRIKA_ID = 104119557;
export const COOKIE_CONSENT_KEY = 'aihub_cookie_consent';

const METRIKA_SRC = `https://mc.yandex.ru/metrika/tag.js?id=${YANDEX_METRIKA_ID}`;
const STARTED_FLAG = '__aihubYandexMetrikaStarted';
const LAST_URL_FLAG = '__aihubYandexMetrikaLastUrl';

export function getCookieConsent() {
  try {
    const value = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (value === 'accepted' || value === 'declined') return value;
  } catch (error) {
    return null;
  }
  return null;
}

export function setCookieConsent(value) {
  try {
    localStorage.setItem(COOKIE_CONSENT_KEY, value);
  } catch (error) {
    // Согласие всё равно действует в текущей сессии, даже если хранилище недоступно.
  }
}

function ensureYmStub() {
  window.ym = window.ym || function ymStub() {
    (window.ym.a = window.ym.a || []).push(arguments);
  };
  if (!window.ym.l) {
    window.ym.l = 1 * new Date();
  }
}

export function startYandexMetrika(url = window.location.href) {
  if (typeof window === 'undefined' || window[STARTED_FLAG]) return;
  window[STARTED_FLAG] = true;

  ensureYmStub();

  const scripts = document.scripts || [];
  let alreadyInserted = false;
  for (let index = 0; index < scripts.length; index += 1) {
    if (scripts[index].src === METRIKA_SRC) {
      alreadyInserted = true;
      break;
    }
  }

  if (!alreadyInserted) {
    const script = document.createElement('script');
    script.async = true;
    script.src = METRIKA_SRC;
    const firstScript = document.getElementsByTagName('script')[0];
    if (firstScript && firstScript.parentNode) {
      firstScript.parentNode.insertBefore(script, firstScript);
    } else {
      (document.head || document.documentElement).appendChild(script);
    }
  }

  window[LAST_URL_FLAG] = url;
  window.ym(YANDEX_METRIKA_ID, 'init', {
    ssr: true,
    webvisor: true,
    clickmap: true,
    ecommerce: 'dataLayer',
    referrer: document.referrer,
    url,
    accurateTrackBounce: true,
    trackLinks: true,
  });
}

export function trackYandexPageview(url) {
  if (typeof window === 'undefined' || !window[STARTED_FLAG] || !url) return;
  if (window[LAST_URL_FLAG] === url) return;

  const referer = window[LAST_URL_FLAG] || document.referrer;
  window[LAST_URL_FLAG] = url;
  ensureYmStub();
  window.ym(YANDEX_METRIKA_ID, 'hit', url, {
    title: document.title,
    referer,
  });
}

export function resetYandexMetrikaState() {
  if (typeof window === 'undefined') return;
  window[STARTED_FLAG] = false;
  window[LAST_URL_FLAG] = '';
  try {
    delete window.ym;
  } catch (error) {
    window.ym = undefined;
  }
}
